export const PasswordStatus = {
	TEMPORARY: "TEMPORARY",
	OWNED: "OWNED",
};
